/**
 * LSDN FAQ — category pill filter
 */
class LsdnFaq extends HTMLElement {
  connectedCallback() {
    this.pills = this.querySelectorAll('[data-category-target]');
    this.panels = this.querySelectorAll('[data-category-panel]');

    if (!this.pills.length || !this.panels.length) {
      return;
    }

    this.nav = this.querySelector('.lsdn-faq__nav');

    this.pills.forEach((pill) => {
      pill.addEventListener('click', () => this.activate(pill));
    });

    const initial =
      this.querySelector('[data-category-target="all"]') ||
      this.querySelector('[data-category-target].is-active') ||
      this.pills[0];
    if (initial) {
      this.activate(initial, { scroll: false });
    }

    this.updateNavScrollState();
    this._onResize = () => this.updateNavScrollState();
    window.addEventListener('resize', this._onResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
  }

  updateNavScrollState() {
    if (!this.nav) {
      return;
    }

    const scrollable = this.nav.scrollWidth > this.nav.clientWidth + 1;
    this.nav.classList.toggle('is-scrollable', scrollable);
  }

  activate(pill, { scroll = true } = {}) {
    const targetId = pill.dataset.categoryTarget;
    if (!targetId) {
      return;
    }

    const showAll = targetId === 'all';

    this.pills.forEach((p) => {
      const isActive = p === pill;
      p.classList.toggle('is-active', isActive);
      p.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.classList.toggle('lsdn-faq--show-all', showAll);

    this.panels.forEach((panel) => {
      panel.hidden = showAll ? false : panel.dataset.categoryPanel !== targetId;
    });

    if (scroll) {
      this.scrollPillIntoView(pill);
    }
  }

  scrollPillIntoView(pill) {
    if (!pill || !this.nav) {
      return;
    }

    const nav = this.nav;
    const maxScroll = Math.max(0, nav.scrollWidth - nav.clientWidth);
    const targetScroll =
      pill.offsetLeft - (nav.clientWidth - pill.offsetWidth) / 2;

    nav.scrollTo({
      left: Math.max(0, Math.min(targetScroll, maxScroll)),
      behavior: 'smooth',
    });
  }
}

if (!customElements.get('lsdn-faq-root')) {
  customElements.define('lsdn-faq-root', LsdnFaq);
}
